import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTwitter, FiLinkedin, FiGithub } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-dark border-t border-primary/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <span className="text-2xl font-bold gradient-text">ColdMail AI</span>
            </Link>
            <p className="text-light/60 max-w-md">
              Generate high-converting cold emails in seconds with AI. 
              Personalize, A/B test, and export outreach emails without the blank page.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Product</h3>
            <ul className="space-y-2">
              <li><Link to="/app" className="text-light/60 hover:text-primary transition-colors">Generator</Link></li>
              <li><Link to="/pricing" className="text-light/60 hover:text-primary transition-colors">Pricing</Link></li>
              <li><Link to="/dashboard" className="text-light/60 hover:text-primary transition-colors">Dashboard</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-light/60 hover:text-primary transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-light/60 hover:text-primary transition-colors">Terms of Service</Link></li>
              <li><a href="mailto:support@coldmail.ai" className="text-light/60 hover:text-primary transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary/20 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-light/60 text-sm">
            © 2024 ColdMail AI. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 sm:mt-0">
            <a href="#" className="text-light/60 hover:text-primary transition-colors">
              <SafeIcon icon={FiTwitter} className="w-5 h-5" />
            </a>
            <a href="#" className="text-light/60 hover:text-primary transition-colors">
              <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
            </a>
            <a href="#" className="text-light/60 hover:text-primary transition-colors">
              <SafeIcon icon={FiGithub} className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;